import { biEventsExecutor } from '../../bi/bi-events';
export const getLoggerDefaultValues = (instanceManager) => {
    const { biToken, appDefId, uid, aid, instanceId } = instanceManager.getInstanceValues();
    return {
        _instanceId: instanceId,
        biToken,
        app_id: appDefId,
        site_member_id: uid ?? null,
        visitor_id: aid ?? null,
        src: 69,
        // TODO: Duplicates _instanceId - some problems in bi lib - they can't remove it :( Remove when they solve it.
        app_instance_id: instanceId,
    };
};
export const initBiMiddleware = (platformApis, instanceManager) => {
    const maybeLoggerFactory = platformApis && platformApis.biLoggerFactory?.();
    // In iframe we get different object here, so lets catch some ducks
    const loggerFactory = maybeLoggerFactory?.logger
        ? // ooi
            maybeLoggerFactory
        : // iframe - factory is nested deeper
            maybeLoggerFactory?.factory?.();
    if (!loggerFactory || !loggerFactory.logger) {
        throw new Error('BI Logger factory not found or is unsupported');
    }
    const logger = loggerFactory.logger();
    const updateLoggerDefaults = () => loggerFactory.updateDefaults(getLoggerDefaultValues(instanceManager));
    updateLoggerDefaults();
    instanceManager.onChange(updateLoggerDefaults);
    return createBiMiddleware(logger, biEventsExecutor);
};
const createBiMiddleware = (logger, biEventsExecutor) => {
    return (store) => (next) => (action) => {
        const result = next(action);
        const state = store.getState();
        try {
            biEventsExecutor({ action, state, logger });
        }
        catch (e) {
            log(`Event ${action.type} bi logger error: ${e}`);
        }
        return result;
    };
};
const log = (message) => {
    process.env.NODE_ENV === 'development' && console.error(message);
};
//# sourceMappingURL=bi-middleware.js.map